import { useEffect, useState } from "react";

export const useImageLoader = (
  webpImg: string,
  mainImg: string,
  shouldLoad: boolean = true
) => {
  const [loading, setLoading] = useState(shouldLoad);

  const preloadImages = (webpImg: string, mainImg: string) => {
    const img = new Image();
    img.src = webpImg;
    img.onload = () => {
      setLoading(false);
    };
  };

  useEffect(() => {
    if (!webpImg || !mainImg || !shouldLoad) return;
    setLoading(true);

    preloadImages(webpImg, mainImg);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading;
};
